'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _format = require('./format');

var _format2 = _interopRequireDefault(_format);

var _log = require('./log');

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//组件错误提示相关，参考next

//cookie相关
exports.default = { cookie: _cookie2.default, format: _format2.default, log: _log2.default }; //格式化相关

module.exports = exports['default'];